<div class="payment-orders-filters">
	<div class="filters-container">
		<div class="refresh-container">
			<button
				(click)="refresh()"
				title="refresh"
				class="refresh-button"
				mat-icon-button
				[attr.data-test]="'refresh-button'"
			>
				<app-icon
					class="refresh-payouts-icon"
					[name]="'rotate-right'"
					[color]="'var(--color-text-default)'"
					[lineWidth]="'1.5px'"
					[size]="'28'"
				></app-icon>
			</button>
		</div>
		<div class="search-container">
			<input-wrapper class="select" [attr.data-test]="'employee-search-autocomplete'">
				<app-search-autocomplete
					[label]="'Search by employee'"
					[searchFn]="searchEmployeeFn"
					[displayWith]="displayEmployeeFn"
					(selectionChanged)="onEmployeeSelected($event)"
				></app-search-autocomplete>
			</input-wrapper>
		</div>
	</div>
	<div class="buttons-container">
		<button
			class="menu-buttons payroll-integration"
			mat-button
			[attr.data-test]="'payroll-integration-button'"
			(click)="runPayrollIntegration()"
		>
			<span class="button-text">
				<app-icon
					class="button-icon"
					[name]="'receipt-add'"
					[color]="'var(--color-upload-button-dark-grey)'"
					[lineWidth]="'1.5px'"
				></app-icon>
				<span class="text-spacing body-small-bold">PAYROLL INTEGRATION</span>
			</span>
		</button>
		<button
			class="menu-buttons payment-order-context"
			[cdkMenuTriggerFor]="menu"
			mat-button
			(cdkMenuClosed)="isPaymentOrderMenuOpen = false"
			(cdkMenuOpened)="isPaymentOrderMenuOpen = true"
			data-test="payment-orders-button"
		>
			<span class="button-text">
				<app-icon
					class="button-icon"
					[name]="'folder'"
					[color]="'var(--color-white)'"
					[lineWidth]="'1.5px'"
				></app-icon>
				<span class="text-white text-spacing body-small-bold">PAYMENT ORDERS</span>
				<app-icon
					class="button-icon last"
					[name]="'arrow-down'"
					[color]="'var(--color-white)'"
					[lineWidth]="'1.5px'"
					[ngClass]="{ 'up-arrow': isPaymentOrderMenuOpen }"
				></app-icon>
			</span>
		</button>
		<input
			id="g2nUploadButton"
			type="file"
			#uploader
			(change)="uploadG2NFile(uploader.files)"
			(click)="uploader.value = ''"
		/>
		<input
			id="cpNowDeductionUploadButton"
			type="file"
			#cpNowUploader
			(change)="uploadCPNDeductionFile(cpNowUploader.files)"
			(click)="cpNowUploader.value = ''"
		/>
		<ng-template #menu>
			<div class="sub-menu" cdkMenu>
				<button
					class="payment-order-actions"
					cdkMenuItem
					(click)="goToFileHistory()"
					data-test="payment-orders-files-button"
				>
					<span class="button-text">
						<app-icon
							class="button-icon"
							[name]="'eye'"
							[color]="'var(--color-upload-button-dark-grey)'"
							[lineWidth]="'1.5px'"
							[size]="'24'"
						></app-icon>
						<span class="text-spacing">Payment Orders Files</span>
					</span>
				</button>
				<button
					id="uploadG2NButton"
					class="payment-order-actions"
					cdkMenuItem
					(click)="uploader.click()"
					[attr.data-test]="'upload-g2n-button'"
					[disabled]="!isEnabledG2NFileUpload"
				>
					<span class="button-text">
						<app-icon
							class="button-icon"
							[name]="isEnabledG2NFileUpload ? 'document-upload' : 'document-upload-disabled'"
							[color]="'var(--color-upload-button-dark-grey)'"
							[lineWidth]="'1.5px'"
							[size]="'24'"
						></app-icon>
						<span class="text-spacing">Upload G2N File</span>
					</span>
				</button>
				@if (isPaymentDeductionEnabled) {
				<button
					id="cpnDeductionUploadButton"
					class="payment-order-actions"
					cdkMenuItem
					(click)="cpNowUploader.click()"
					[attr.data-test]="'upload-g2n-button'"
					[disabled]="!isEnabledCPNDeductionUpload"
				>
					<span class="button-text">
						<app-icon
							class="button-icon"
							[name]="isEnabledCPNDeductionUpload ? 'document-upload' : 'document-upload-disabled'"
							[color]="'var(--color-upload-button-dark-grey)'"
							[lineWidth]="'1.5px'"
							[size]="'24'"
						></app-icon>
						<span class="text-spacing">Upload CP App Deductions</span>
					</span>
				</button>
				}
			</div>
		</ng-template>
	</div>
</div>
